<template>
  <v-tooltip v-if="visible" :disabled="!tooltip" top content-class="construct-visual-html-tooltip">
    <template v-slot:activator="{ on, attrs }">
      <div v-bind="attrs" v-on="on" class="construct-visual-html" :class="item.size || 'body-2'" v-html="html" />
    </template>
    <div class="construct-visual-html" v-html="tooltip" />
  </v-tooltip>
</template>

<script>
import displayMixin from './mixin'
import { sanitizeVisualHtml } from './sanitizeHtml'

export default {
  name: 'ConstructVisualDisplayHtml',
  mixins: [displayMixin],
  computed: {
    html() { return sanitizeVisualHtml(this.resolveValue(this.item.value), this.item.limitCaracter) },
    tooltip() { return sanitizeVisualHtml(this.resolveTemplate(this.item.tooltip)) },
    visible() { return !this.item.hideempty || this.html !== '' },
  },
}
</script>

<style scoped>
.construct-visual-html {
  min-width: 0;
  max-width: 100%;
  overflow-wrap: anywhere;
  overflow-x: auto;
  line-height: 1.2;
}

.construct-visual-html ::v-deep p {
  margin: 2px 0;
  line-height: 1.2;
}

.construct-visual-html ::v-deep img {
  max-width: 100%;
  height: auto;
}

.construct-visual-html ::v-deep > :last-child {
  margin-bottom: 0;
}
</style>

<style>
.construct-visual-html-tooltip {
  max-width: 480px;
  max-height: 60vh;
  overflow: auto;
}
</style>
